// extracted by mini-css-extract-plugin
export default {"zoomControls":"Jaa-z","zoomControlButton":"Kaa-z","zoomBanner":"Laa-z","bannerButton":"Maa-z","imageButton":"Naa-z","zoom":"Oaa-z","zoomContent":"Paa-z"};